import styled, {
  BoxShadows,
  Device,
  Scale,
  boxShadows,
  breakpoints,
  css,
} from '@secretescapes/falcon';
import { type CommonStyledProps, mediaQuery } from '@utils/styles.utils';

interface StickyContainerWrapperProps {
  isSticky: boolean;
}

// Override sticky container to take in to account the headers.
export const StickyContainerWrapper = styled('div')<StickyContainerWrapperProps>`
  width: 100%;

  > div > div {
    top: 0;
    ${({ isSticky }) => !isSticky && `position: unset`};
  }
`;

export const OuterContainer = styled('div')<CommonStyledProps>`
  margin: ${({ isMobile }) => !isMobile && `${Scale.xs} 0`};
`;

interface StickyElementContainerProps extends CommonStyledProps {
  isSticky: boolean;
}

export const StickyElementContainer = styled('div')<StickyElementContainerProps>(
  ({ isSticky, isMobile, theme }) =>
    isMobile
      ? css`
          ${isSticky && `box-shadow: ${boxShadows[BoxShadows.level1]};`}
        `
      : css`
          width: 100vw;
          display: flex;
          align-items: center;
          padding: ${Scale.m} 0;
          background-color: ${theme.color.white};
          ${isSticky && `box-shadow: ${boxShadows[BoxShadows.level1]};`}

          @media ${mediaQuery.tablet} {
            padding: ${Scale.m} 0;
            ${isSticky && `min-height:78px; align-items: flex-end;`}
          }

          @media (min-width: ${breakpoints[Device.desktop]}) {
            width: 100%;
            justify-content: center;
          }
        `
);
